<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'GoogleMixin',

        data() {
            return {
                clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                apiUrl: process.env.VUE_APP_SEEKER_API_URL,
                is_register: false,
            };
        },

        computed: {
            getLogo() {
                return `${
                    process.env.VUE_APP_URL
                }${require('@/assets/img/google.svg')}`;
            },
            getOauthParams() {
                const site_code = this.$axios.defaults.headers.common['site-code'];

                return {
                    client_id: this.clientId,
                    redirect_uri: `${this.apiUrl}/v1/login/google`,
                    scope: 'openid profile email',
                    response_type: 'code',
                    state: JSON.stringify({
                        register: this.is_register,
                        site_code: site_code,
                    }),
                };
            },
        },

        async mounted() {
            window.addEventListener('message', this.oauthListener, true);
        },

        beforeDestroy() {
            window.removeEventListener('message', this.oauthListener);
        },

        methods: {
            ...mapActions('auth', {
            }),

            oauthListener(e) {
                if (
                    this.apiUrl.startsWith(e.origin) &&
                    e.data.action == 'google_oauth'
                ) {
                    this.afterLogin(e.data.data);
                }
            },

            afterLogin() {},

            async signInGoogle() {
                const params = new URLSearchParams(this.getOauthParams);
                const url = `${process.env.VUE_APP_GOOGLE_OAUTH_URL}?${params.toString()}`;
                const newWindow = window.open(url, '_blank');
                newWindow.focus();
                // this.popupCenter({
                //     url: url,
                //     title: '_blank',
                //     w: 400,
                //     h: 400,
                // });
            },

            popupCenter: ({ url, title, w, h }) => {
                // Fixes dual-screen position  Most browsers      Firefox
                const dualScreenLeft =
                    window.screenLeft !== undefined
                        ? window.screenLeft
                        : window.screenX;
                const dualScreenTop =
                    window.screenTop !== undefined
                        ? window.screenTop
                        : window.screenY;

                const clientWidth = document.documentElement.clientWidth
                    ? document.documentElement.clientWidth
                    : screen.width;
                const clientHeight = document.documentElement.clientHeight
                    ? document.documentElement.clientHeight
                    : screen.height;
                const width = window.innerWidth ? window.innerWidth : clientWidth;
                const height = window.innerHeight
                    ? window.innerHeight
                    : clientHeight;

                const systemZoom = width / window.screen.availWidth;
                const left = (width - w) / 2 / systemZoom + dualScreenLeft;
                const top = (height - h) / 2 / systemZoom + dualScreenTop;
                const newWindow = window.open(
                    url,
                    title,
                    `
                              scrollbars=yes,
                              width=${w / systemZoom}, 
                              height=${h / systemZoom}, 
                              top=${top}, 
                              left=${left}
                              `,
                );

                if (window.focus) newWindow.focus();
            },
        },
    };
</script>